import Modal from "shared/components/Modal";
import Button from "shared/components/Button";
import { usePoiDelete } from "./usePoiDelete";
import { useCallback } from "react";

interface PoiDeleteProps {}

const PoiDelete: React.FC<PoiDeleteProps> = () => {
  const [modalOpen, setModalOpen, loading, deletePoi] = usePoiDelete();

  const closeModal = useCallback(() => {
    // TODO: Cancel POI Delete process
    setModalOpen(false);
  }, [setModalOpen]);

  return (
    <Modal
      open={modalOpen}
      closeModal={closeModal}
      btnsDisabled={loading}
      closeDisabled={loading}
      showSpinner={loading}
      title="Delete Scout Point"
      underlayClass="FaintUnderlay"
      actionButton={
        <Button
          colour="Red"
          additionalClassNames="PrimaryButton Large"
          onClick={deletePoi}
          disabled={loading}
        >
          Delete
        </Button>
      }
      debugMode
    >
      <p>Are you sure you want to delete the Scout Point?</p>
    </Modal>
  );
};

export default PoiDelete;
